import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "toast-mask",
  style: {
    "opacity": "0"
  }
};
const _hoisted_2 = {
  class: "toast-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.classes)
  }, [_withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [[_vShow, $props.isShow]]), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
      class: "toast-content",
      style: _normalizeStyle($data.styles)
    }, [$props.type === 'msg' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createTextVNode(_toDisplayString($props.message), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createElementVNode("em", {
      class: _normalizeClass(["toast-icon", $options.iconClass])
    }, null, 2), _createElementVNode("div", _hoisted_2, _toDisplayString($props.message), 1)], 64))], 4), [[_vShow, $props.isShow]])]),
    _: 1
  })], 2)), [[_vShow, $props.isShow]]);
}